import { render, staticRenderFns } from "./AddGroupUser.vue?vue&type=template&id=446b2d6c&scoped=true"
import script from "./AddGroupUser.vue?vue&type=script&lang=js"
export * from "./AddGroupUser.vue?vue&type=script&lang=js"
import style0 from "./AddGroupUser.vue?vue&type=style&index=0&id=446b2d6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446b2d6c",
  null
  
)

/* custom blocks */
import block0 from "./AddGroupUser.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports